export const CURRENT_FISCAL_YEAR_NAME = '२०८३/०८४';

export const pickCurrentFiscalYear = (fiscalYears = []) => {
  if (!Array.isArray(fiscalYears) || fiscalYears.length === 0) {
    return null;
  }

  return fiscalYears.find((item) => item?.is_current) || fiscalYears[0] || null;
};

export const findFiscalYearById = (fiscalYears = [], fiscalYearId) => {
  if (!fiscalYearId) {
    return null;
  }

  return (fiscalYears || []).find((item) => Number(item?.id) === Number(fiscalYearId)) || null;
};

export const keepOrDefaultFiscalYear = (fiscalYears = [], previous = null) => {
  const matched = findFiscalYearById(fiscalYears, previous?.id);
  if (matched) {
    return matched;
  }

  return pickCurrentFiscalYear(fiscalYears);
};

export const normalizeBudgetFiscalYearLabel = (value = '') => String(value ?? '').trim();

export const normalizeBudgetSubmissionFiscalYear = (submission = null) => {
  if (!submission || typeof submission !== 'object') {
    return submission;
  }

  return {
    ...submission,
    fiscal_year_display: normalizeBudgetFiscalYearLabel(submission.fiscal_year_display || '')
  };
};

export const normalizeBudgetFiscalYears = (fiscalYears = []) => (
  Array.isArray(fiscalYears)
    ? fiscalYears.map((item) => ({
        ...item,
        name: normalizeBudgetFiscalYearLabel(item?.name || '')
      }))
    : []
);
